<!--
 * @Author: wencd wencd@yxt.com
 * @Date: 2022-09-20 18:23:44
 * @LastEditors: wencd wencd@yxt.com
 * @LastEditTime: 2022-09-30 16:49:14
 * @FilePath: \yxt-biz-pc\packages\board-audit\src\main.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="yxtbiz-board-audit">
    <div class="standard-size-16 color-gray-10">
      <div class="font-bolder">{{$t('pc_biz_bbs_lbl_authorInfo'/**作者信息 */)}}</div>
      <yxtf-row type="flex" class="mv24 font-normal font-size-14">
        <yxtf-col :span="12" class="mh2 flex">
          <span class="color-gray-7 nowrap">{{ $t('pc_biz_bbs_lbl_name' /** 姓名 */) }}：</span>
          <span v-if="detail.anonymous === 1">{{$t('pc_biz_bbs_lbl_anonymous'/**匿名 */)}}</span>
          <yxtf-tooltip
            v-else
            :open-filter="true"
            placement="top">
            <div  slot="content">
              <yxtbiz-user-name
                :name="detail.fullName"
              />
              <span>{{'（'+detail.userName+'）'}}</span>
            </div>
            <div class="yxtbiz-board-audit_ellipsis">
              <yxtbiz-user-name
                :name="detail.fullName || ''"
              />
              <span v-show="detail.userName">{{'（'+detail.userName+'）'}}</span>
            </div>
          </yxtf-tooltip>
        </yxtf-col>
        <yxtf-col :span="12" class="mh2 flex">
          <span class="color-gray-7 nowrap">{{ $t('pc_biz_bbs_lbl_dept' /**  部门 */) }}：</span>
          <yxtf-tooltip v-if="!detail.anonymous" placement="top" :open-filter="true">
            <yxtbiz-dept-name
              slot="content"
              :name="detail.deptName"
            />
            <yxtbiz-dept-name
              class="yxtbiz-board-audit_ellipsis"
              :name="detail.deptName || '--'"
            />
          </yxtf-tooltip>
          <span v-else>--</span>
        </yxtf-col>
      </yxtf-row>
      <yxtf-row type="flex" class="mv24 font-normal font-size-14">
        <yxtf-col :span="12" class="mh2 flex">
          <span class="color-gray-7 nowrap">{{ $t('pc_biz_bbs_lbl_possion' /**岗位 */) }}：</span>
          <yxtf-tooltip v-if="!detail.anonymous" :open-filter="true" placement="top">
            <yxtbiz-position-name
            slot="content"
            :name="detail.positionName"
            />
            <yxtbiz-position-name class="yxtbiz-board-audit_ellipsis" :name="detail.positionName || '--'" />
          </yxtf-tooltip>
          <span v-else>--</span>
        </yxtf-col>
      </yxtf-row>
      <yxtf-row type="flex" class="font-normal font-size-14">
          <yxtf-col :span="16" class="mh2 flex">
            <span class="color-gray-7 nowrap">{{$t('pc_biz_bbs_lbl_content'/**内容 */)}}：</span>
            <yxtf-tooltip
              :open-filter="true"
              :content="detail.title"
              placement="top">
              <div class="yxtbiz-board-audit_ellipsis">{{ detail.title || '--' }}</div>
            </yxtf-tooltip>
             <span class="ml8 hand yxtbiz-board-color-detail" @click="goDetail">{{$t('pc_biz_bbs_lbl_viewDetail'/**查看详情 */)}}</span>
          </yxtf-col>
        </yxtf-row>
    </div>
  </div>
</template>

<script>
import { getPostDeatilApi } from './service';
export default {
  name: 'YxtbizBoardAudit',
  name_zh: '社区板块接审核中心',
  props: {
    id: {
      type: String,
      default: '',
      desc: '详情id',
      setter: 'StringSetter'
    }
  },
  data() {
    return {
      detail: {}
    };
  },
  created() {
    this.getPostDeatil();
  },
  methods: {
    getPostDeatil() {
      getPostDeatilApi(this.id).then(res => {
        this.detail = res || {};
      });
    },
    goDetail() {
      let href = window.location.origin + `/bbs/#/postdetail/${this.id}?from=mgmt`;
      window.open(href, '_blank');
    }
  }
};
</script>
